import { css } from '@emotion/react';


export default ($) => css`
  .border {
    border: ${$.borderWidth} solid ${$.borderColor} !important;
  }
  .border-top {
    border-top: ${$.borderWidth} solid ${$.borderColor} !important;
  }
  .border-right {
    border-right: ${$.borderWidth} solid ${$.borderColor} !important;
  }
  .border-bottom {
    border-bottom: ${$.borderWidth} solid ${$.borderColor} !important;
  }
  .border-left {
    border-left: ${$.borderWidth} solid ${$.borderColor} !important;
  }
  
  .border-0 {
    border: 0 !important;
  }
  .border-top-0 {
    border-top: 0 !important;
  }
  .border-right-0 {
    border-right: 0 !important;
  }
  .border-bottom-0 {
    border-bottom: 0 !important;
  }
  .border-left-0 {
    border-left: 0 !important;
  }

  ${css(Object.entries($.themeColors).map(([color, value]) => `
    .border-${color} {
      border-color: ${value} !important;
    }
  `))}
  
  .border-white {
    border-color: ${$.white} !important;
  }

  .rounded-sm {
    border-radius: ${$.borderRadiusSm} !important;
  }

  .rounded {
    border-radius: ${$.borderRadius} !important;
  }

  .rounded-top {
    border-top-left-radius: ${$.borderRadius} !important;
    border-top-right-radius: ${$.borderRadius} !important;
  }

  .rounded-right {
    border-top-right-radius: ${$.borderRadius} !important;
    border-bottom-right-radius: ${$.borderRadius} !important;
  }

  .rounded-bottom {
    border-bottom-right-radius: ${$.borderRadius} !important;
    border-bottom-left-radius: ${$.borderRadius} !important;
  }

  .rounded-left {
    border-top-left-radius: ${$.borderRadius} !important;
    border-bottom-left-radius: ${$.borderRadius} !important;
  }

  .rounded-lg {
    border-radius: ${$.borderRadiusLg} !important;
  }

  .rounded-circle {
    border-radius: 50% !important;
  }

  .rounded-pill {
    border-radius: ${$.roundedPill} !important;
  }

  .rounded-0 {
    border-radius: 0 !important;
  }
`;
